import StandsGlobalConst from "./stands-global-const";
import StandsGlobalFields from "./fields";
import StandsGlobalFilters from "./filters";
import StandsGlobalForms from "./forms";
import StandsGlobalHelpers from "./helpers";

const StandsGlobal = {
    Const: StandsGlobalConst,
    Fields: StandsGlobalFields,
    Filters: StandsGlobalFilters,
    Forms: StandsGlobalForms,
    Helpers: StandsGlobalHelpers,
}

export default StandsGlobal;
